import React, { useState } from 'react';
import VelvetLogo from '../icons/VL_WordmarkOnly_Light.svg';
import '../styles/Modal.css';
import '../styles/WelcomeModal.css';

const WelcomeModal = ({ isOpen, onClose, onComplete }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      showLogo: true,
      title: 'Welcome to Velvet',
      subtitle: 'Your all-in-one platform for content creation and management'
    },
    {
      showLogo: true,
      title: 'Organize Your Content',
      subtitle: 'Manage sources, ideas, and content all in one place'
    },
    {
      showLogo: true,
      title: 'Collaborate with Your Team',
      subtitle: 'Work together seamlessly with real-time updates and notifications'
    },
    {
      showLogo: true,
      title: 'Get Started Today',
      subtitle: 'Let\'s create something amazing together'
    }
  ];

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      handleComplete();
    }
  };

  const handlePrevious = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const handleComplete = () => {
    setCurrentSlide(0);
    if (onComplete) {
      onComplete();
    }
    onClose();
  };

  const handleClose = () => {
    setCurrentSlide(0);
    if (onComplete) {
      onComplete();
    }
    onClose();
  };

  if (!isOpen) return null;

  const isLastSlide = currentSlide === slides.length - 1;
  const isFirstSlide = currentSlide === 0;

  return (
    <div className="modal-overlay welcome-modal-overlay">
      <div className="modal-content welcome-modal-content">
        <button className="modal-close-btn welcome-modal-close" onClick={handleClose} aria-label="Close" />

        <div className="welcome-slide">
          {slides[currentSlide].showLogo && (
            <div className="welcome-logo-container">
              <img src={VelvetLogo} alt="Velvet" className="welcome-logo" />
            </div>
          )}

          <h2 className="welcome-title">{slides[currentSlide].title}</h2>
          <p className="welcome-subtitle">{slides[currentSlide].subtitle}</p>

          <div className="welcome-pagination">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`pagination-dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="welcome-navigation">
          {!isFirstSlide && (
            <button className="modal-btn modal-btn-cancel" onClick={handlePrevious}>
              Previous
            </button>
          )}
          <button className="modal-btn modal-btn-confirm welcome-btn-next" onClick={handleNext}>
            {isLastSlide ? 'Get Started' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
